import { render, staticRenderFns } from "./mohon-pindaan.vue?vue&type=template&id=0487ccd8&"
import script from "./mohon-pindaan.vue?vue&type=script&lang=js&"
export * from "./mohon-pindaan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports